import request from "@/utils/request";

export async function category() {
  //分类
  return (
    await request({
      url: `/product-service/category/list`,
      method: "get",
    })
  ).data;
}
export async function seasonList() {
  //季节
  return (
    await request({
      url: `/product-service/season/activeList`,
      method: "get",
    })
  ).data;
}

// export async function getVendors(params) { //获取店铺list
//   return (await request({
//     url: `/basic-backend/promotion/investment/vendors`,
//     method: "get",
//     params,
//   })).data;
// }

//note: 折扣管理/  日常折扣

//买手店列表 & 根据母店获取子店列表
export async function getVendorsByVendorName(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/discount/vendorInfo`,
      method: "post",
      data,
    })
  ).data;
}

/// 折扣店铺列表接口
export async function getDiscountVendorList(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/discount/vendorList`,
      method: "post",
      data,
    })
  ).data;
}

// 当前母店下待生效季节及时间接口
export async function pendingSeason(id) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/discount/pendingSeason?vendorId=${id}`,
      method: "get",
    })
  ).data;
}

// 店铺维度折扣复制功能接口
export async function priceChangeRuleCopy(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/discount/vendor/priceChangeRule/copy`,
      method: "post",
      data,
    })
  ).data;
}

// 查询买手店折扣生效状态
export function discountStatus(vendorId) {
  return request({
    url: `/sc-basic-merchant-backend/discount/twoState/${vendorId}`,
    method: "get",
  });
}

// 查询买手店指定状态的季节
export function discountStatusSeason(vendorId, status) {
  return request({
    url: `/sc-basic-merchant-backend/discount/seasons?vendorId=${vendorId}&status=${status}`,
    method: "get",
  });
}

// 批量下载文件
export async function ruleBatchDownload(params) {
  return request({
    url: `/sc-basic-merchant-backend/price/change/rule/downloadByQueryParam`,
    method: "get",
    params,
    responseType: "blob",
  });
}

//note: 折扣管理/  日常折扣->买手店折扣页面

//买手店折扣页面-日常折扣列表
export async function diaryDisountList(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/list`,
      method: "post",
      data,
    })
  ).data;
}
//买手店折扣页面-查询全部季节接口
export async function getAllSeasons(id) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/season/code/list/${id}`,
      // url: `http://172.16.24.147:8280/season/code/list/${id}`,
      method: "get",
    })
  ).data;
}

//买手店折扣 - 下载买手店折扣信息
export async function ruleDownload(id) {
  return request({
    url: `/sc-basic-merchant-backend/price/change/rule/download?priceChangeRuleId=${id}`,
    method: "get",
  });
}

//买手店折扣页面-删除待生效的折扣
export async function delDiscount(id) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/del?priceChangeRuleId=${id}`,
      method: "get",
    })
  ).data;
}

//买手店折扣页面-待生效的折扣编辑生效时间
export async function ruleUpdate(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/edit`,
      method: "post",
      data,
    })
  ).data;
}
//下载模版
export function getTemplateUrl(type, vendorId) {
  return request({
    url: `/sc-basic-merchant-backend/price/change/rule/template?categoryType=${type}&vendorId=${vendorId}`,
    method: "get",
  });
}
//买手店折扣页面-解析上传文件
export async function analysis(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/file/analysis`,
      // url: `http://172.16.24.147:8280/price/change/rule/file/analysis`,
      method: "post",
      data,
    })
  ).data;
}
export async function compare(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/file/analysis/compare/async`,
      // url: `http://172.16.24.147:8280/price/change/rule/file/analysis/compare`,
      method: "post",
      data,
    })
  ).data;
}
export async function compareResult(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/file/analysis/compare/result`,
      // url: `http://172.16.24.147:8280/price/change/rule/file/analysis/compare`,
      method: "post",
      data,
    })
  ).data;
}
//买手店折扣页面-新建折扣信息
export async function ruleCreate(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/create`,
      // url: `http://172.16.24.147:8280/price/change/rule/create`,
      method: "post",
      data,
    })
  ).data;
}
//买手店折扣页面-复制折扣功能
export async function ruleCopy(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/copy`,
      method: "post",
      data,
    })
  ).data;
}

//note: 折扣管理/  日常折扣  /折扣查看

//买手店折扣页面-查询二级折扣列表
export async function getAllCategory2(id) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/category2/list?priceChangeRuleId=${id}`,
      method: "get",
    })
  ).data;
}

//买手店折扣页面-查询三级折扣列表
export async function getAllCategory3(id) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/category3/list?priceChangeRuleId=${id}`,
      method: "get",
    })
  ).data;
}

//买手店折扣页面-查询四级折扣列表
export async function getAllCategory4(id) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/category4/list?priceChangeRuleId=${id}`,
      method: "get",
    })
  ).data;
}

// 买手店折扣页面-获取特殊商品折扣列表
export async function getBoutiqueProductRate(id) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/exception/boutique/product?priceChangeRuleId=${id}`,
      method: "get",
    })
  ).data;
}

// 买手店折扣页面-提交
export async function submitBoutiqueProductDiscount(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/submit`,
      method: "post",
      data,
    })
  ).data;
}

export async function fileUpload() {
  return (
    await request({
      url: `/oss/file-upload-auth-sts`,
      method: "GET",
    })
  ).data;
}

export async function getDiscountPromotionVendorList(data) {
  return (
    await request({
      url: `/sc-merchant-common/v2/promotion/vendors`,
      method: "post",
      data,
    })
  ).data;
}

export async function getVendorPromotionList(vendorId, data) {
  return (
    await request({
      url: `/basic-backend/promotion/join/${vendorId}/list`,
      method: "post",
      data,
    })
  ).data;
}

export async function getVendorPromotionDetail(vendorId, salesPromotionId) {
  return (
    await request({
      url: `/basic-backend/promotion/join/${vendorId}/${salesPromotionId}/copy/details`,
      method: "get",
    })
  ).data;
}

export async function copyVendorPromotion(vendorId, salesPromotionId, data) {
  return (
    await request({
      url: `/basic-backend/promotion/join/${vendorId}/${salesPromotionId}/copy`,
      method: "post",
      data,
    })
  ).data;
}

export async function getPromotionVendorDiscountSeason(vendorId, params) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/${vendorId}/season/code/list`,
      method: "get",
      params,
    })
  ).data;
}

export async function getVendorPromotionDiscountList(
  vendorId,
  salesPromotionId,
  data
) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/${vendorId}/${salesPromotionId}/list`,
      method: "post",
      data,
    })
  ).data;
}

export async function getPromotionVendorDiscountTemplate(vendorId, params) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/${vendorId}/template`,
      method: "get",
      params,
    })
  ).data;
}

export async function analysisPromotionVendorDiscount(vendorId, data) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/${vendorId}/file/analysis`,
      method: "post",
      data,
    })
  ).data;
}

export async function createPromotionVendorDiscount(vendorId, data) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/${vendorId}/create`,
      method: "post",
      data,
    })
  ).data;
}

export async function copyPromotionVendorDiscount(vendorId, data) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/${vendorId}/copy`,
      method: "post",
      data,
    })
  ).data;
}

export async function downloadPromotionVendorDiscount(vendorId, data) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/${vendorId}/download`,
      method: "post",
      data,
    })
  ).data;
}

export async function deletePromotionVendorDiscount(vendorId, data) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/${vendorId}/del`,
      method: "post",
      data,
    })
  ).data;
}

export async function getPromotionVendorDiscountConfig(
  vendorId,
  salesPromotionId
) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/${vendorId}/${salesPromotionId}/config`,
    })
  ).data;
}

export async function savePromotionVendorDiscountConfig(
  vendorId,
  salesPromotionId,
  data
) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/${vendorId}/${salesPromotionId}/config`,
      method: "post",
      data,
    })
  ).data;
}

export async function getPromotionVendorDiscountCategory2List(id) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/detail/category2/list?salesPromotionVendorRuleSeasonId=${id}`,
    })
  ).data;
}

export async function getPromotionVendorDiscountCategory3List(id) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/detail/category3/list?salesPromotionVendorRuleSeasonId=${id}`,
    })
  ).data;
}

export async function getPromotionVendorDiscountSpecialProductList(id) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/detail/special/product?salesPromotionVendorRuleSeasonId=${id}`,
    })
  ).data;
}

export async function submitPromotionVendorDiscountDetail(
  salesPromotionVendorRuleSeasonId,
  data
) {
  return (
    await request({
      url: `/basic-backend/promotion/discount/detail/submit/${salesPromotionVendorRuleSeasonId}`,
      method: "post",
      data,
    })
  ).data;
}

export async function checkPriceChangeRule(id) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/price/change/rule/check?priceChangeRuleId=${id}`,
    })
  ).data;
}

export async function priceChangeRuleCopyCheck(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/discount/vendor/priceChangeRule/copy/check`,
      method: "post",
      data,
    })
  ).data;
}

export async function getPromotionSkuList(salesPromotionId, vendorId, params) {
  return (
    await request({
      url: `/basic-backend/promotion/sku/discount/${salesPromotionId}/${vendorId}/list`,
      method: "get",
      params,
    })
  ).data;
}

export async function exportPromotionSkuList(salesPromotionId, vendorId) {
  return (
    await request({
      url: `/basic-backend/promotion/sku/discount/${salesPromotionId}/${vendorId}/export`,
      method: "get",
    })
  ).data;
}

export async function delAllPromotionSku(salesPromotionId, vendorId) {
  return (
    await request({
      url: `/basic-backend/promotion/sku/discount/${salesPromotionId}/${vendorId}/del/all`,
      method: "post",
    })
  ).data;
}

export async function delPromotionSku(salesPromotionId, vendorId, data) {
  return (
    await request({
      url: `/basic-backend/promotion/sku/discount/${salesPromotionId}/${vendorId}/del`,
      method: "post",
      data,
    })
  ).data;
}

export async function getDailySkuList(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/sku/discount/page`,
      method: "post",
      data,
    })
  ).data;
}

export async function exportDailySkuList(params) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/sku/discount/export`,
      method: "get",
      params,
    })
  ).data;
}

export async function delAllDailySku(params) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/sku/discount/clear/all`,
      method: "get",
      params,
    })
  ).data;
}

export async function delDailySku(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/sku/discount/batch/del`,
      method: "post",
      data,
    })
  ).data;
}

export async function getSupplyPriceRuleList(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/supply/price/rule/manage/list`,
      method: "post",
      data,
    })
  ).data;
}

export async function getSupplyPriceRuleDetail(params) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/supply/price/rule/manage/detail`,
      method: "get",
      params,
    })
  ).data;
}

export async function saveSupplyPriceRule(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/supply/price/rule/manage/save`,
      method: "post",
      data,
    })
  ).data;
}

export function downloadFileUrl(url) {
  return request({
    url,
    responseType: "blob",
  });
}

export async function invalidSupplyPriceRule(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/supply/price/rule/manage/invalid`,
      method: "post",
      data,
    })
  ).data;
}

export async function getBpDocPageList(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/bp/doc/pageList`,
      method: "post",
      data,
    })
  ).data;
}

export async function getBpSkuList(boutiqueProductId) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/bp/sku/list/${boutiqueProductId}`,
      method: "get",
    })
  ).data;
}

export async function exportBpDocPageList(data) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/bp/doc/export`,
      method: "post",
      data,
    })
  ).data;
}

export async function getExportHistory(params) {
  return (
    await request({
      url: `/sc-basic-merchant-backend/bp/doc/export/history`,
      method: "get",
      params,
    })
  ).data;
}

export function queryVendorList(data) {
  return request({
    url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeSeller`,
    method: "post",
    data,
  });
}

export function queryNewVendorList(data) {
  return request({
    url: `/sc-basic-merchant-backend/supply/price/rule/manage/vendor/list`,
    method: "post",
    data,
  });
}

export function getFourCategoryList(params) {
  return request({
    url: "/basic-backend/category/list?flat=false",
    method: "get",
    params,
  });
}

export async function appendSku(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/supply/price/rule/manage/sku/append`,
    method: "post",
    data,
  })).data;
}

export async function getSkuFileList(data) {
  return (await request({
    url: `/sc-basic-merchant-backend/supply/price/rule/manage/sku/file/list`,
    method: "post",
    data,
  })).data;
}
